module.exports = __webpack_public_path__ + "static/media/supermedico.10c9d169.png";